import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, signal } from "@angular/core";

import { StrategyEx } from "@front/m19-models";
import { IDropdownMenuSeparatorComponent, ISelectMenuImports, Option } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { ActivityEventAnnotationsService, ActivityEventType } from "./activities/activity-event-annotations.service";

@Component({
  selector: "app-activity-event-filters",
  imports: [TranslocoDirective, ISelectMenuImports, IDropdownMenuSeparatorComponent],
  templateUrl: "./activity-event-filters.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityEventFiltersComponent implements OnInit {
  readonly activityEventAnnotationsService = inject(ActivityEventAnnotationsService);

  displayEventAnnotation = input<boolean>(false);
  disableEventAnnotation = input<boolean>(false);

  allEventAnnotationTypes = input<Option<ActivityEventType>[] | undefined>(undefined);
  selectedEventAnnotationTypes = signal<Option<ActivityEventType>[]>([]);

  allStrategies = input<Option<StrategyEx>[] | undefined>(undefined);
  selectedStrategies = signal<Option<StrategyEx>[]>([]);

  queryFilterAnnotationTypes = signal<string>("");
  queryFilterStrategies = signal<string>("");

  filteredEventAnnotationTypes = computed(() => {
    return this.allEventAnnotationTypes()?.filter((o) =>
      o.label.toLowerCase().includes(this.queryFilterAnnotationTypes().toLowerCase()),
    );
  });

  filteredStrategies = computed(() => {
    return this.allStrategies()?.filter((o) =>
      o.label.toLowerCase().includes(this.queryFilterStrategies().toLowerCase()),
    );
  });

  ngOnInit(): void {
    this.selectedEventAnnotationTypes.set(this.allEventAnnotationTypes() ?? []);
    this.selectedStrategies.set(this.allStrategies() ?? []);
  }

  selectEventAnnotationTypes(eventAnnotationTypes: Option<ActivityEventType>[] | undefined) {
    this.selectedEventAnnotationTypes.set(eventAnnotationTypes ?? []);
    this.activityEventAnnotationsService.selectActivityEventAnnotationTypes(
      eventAnnotationTypes?.map((o) => o.value) ?? [],
    );
  }

  selectStrategies(strategies: Option<StrategyEx>[] | undefined) {
    this.selectedStrategies.set(strategies ?? []);
    this.activityEventAnnotationsService.selectStrategies(strategies?.map((o) => o.value) ?? []);
  }
}
